import CustomTooltip from "app/components/Tooltip";
import Avatar from "app/containers/Features/components/Avatar";
import CommonAssigneeSelection from "app/containers/Features/components/CommonAssigneeSelection";
import { IMember } from "app/containers/Features/containers/ProjectSettings/types";
import { selectTeamMembers } from "app/redux/selector";
import { UserIcon } from "lucide-react";
import React, { useState } from "react";
import { useSelector } from "react-redux";

interface AssigneeSelectionProps {
  assignedTo: {
    name: string;
    color: string;
    status?: "online" | "offline";
    online: boolean;
  }[];
  dropdownTrigger?: React.ReactNode;
  dropdownContainerClassName?: string;
  className?: string; 
  dropdownPlaceholder?: string;
}

const Assignee: React.FC<AssigneeSelectionProps> = ({ assignedTo,dropdownTrigger,dropdownContainerClassName, className,dropdownPlaceholder }) => {
  const [search, setSearch] = useState("");
  const selectTeamMember = useSelector(selectTeamMembers) 

  const searchMembers = (members, keyword: string): IMember[] => {
      if (!keyword) return members;
      return members.filter(
        (member) =>
          member.name.toLowerCase().includes(keyword.toLowerCase()) ||
          member.role.toLowerCase().includes(keyword.toLowerCase())
      );
    };

  const filteredMembers = searchMembers(selectTeamMember, search);

  return (
    <>
      <CommonAssigneeSelection
        trigger={
          dropdownTrigger ?? (
            <button className="flex items-center justify-between w-full p-[6px] rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-[#79808A] ">
              <CustomTooltip
                text="Set assignee"
                className="flex items-center gap-1   "
                position="left"
              >
                <UserIcon size={16} color="#79808A"/>
                {assignedTo?.map((assignee, index) => (
                  <Avatar
                    key={index}
                    color={assignee?.color??"#FFC803"}
                    name={assignee?.name}
                    className=" w-full truncate"
                    circleClassName="text-[6.4px] leading-[19.2px] font-normal !size-[16px]"
                    statusClassName="size-[3.2px]"
                    nameClassName="text-xs leading-[18px] font-normal text-secondary truncate"
                    detailsClassName="w-full"
                  />
                ))}
              </CustomTooltip>
            </button>
          )
        }
        align="center"
        searchKeyword={search}
        setSearchKeyword={(val) => {
          setSearch(val);
        }}
        data={filteredMembers}
        selectedValue={assignedTo?.map((a) => a.name).join(", ") ?? ""}
        updateValue={() => { }}
        isHeader="Assignees"
        searchPlaceholder={`${dropdownPlaceholder ?? "Search by assignee or role"}`}
        dropdownContainerClassName={dropdownContainerClassName}
        className={`${className} min-w-[255px]`}
      />
    </>
  );
};

export default Assignee;
